import React, { Component } from 'react';
import { Map } from 'immutable';
import PropTypes from 'prop-types';
import connect from '../store/connect';
import { fetchProducts, fetchCategoryMetaData, setViewstate, removeViewstate } from '../actions/actionCreators';
import Page from './Page';
import { Heading } from '../styles/Heading';
import { Preamble } from '../styles/Preamble';
import { Container } from '../styles/Container';
import ProductListWithFilters from '../components/ProductListWithFilters';
import { getProductsByKeys } from '../selectors/reselectCategory';
import { color } from '../styles/helpers/variables';
import ErrorPage from './ErrorPage';
import NotFoundPage from './NotFoundPage';

class CategoryPage extends Component {
  componentDidMount() {
    this.getPageData(this.props.match.url, this.props.item.get('id'));

    if (this.props.viewstate.get('currentCategory') !== this.props.item.get('id')) {
      this.setDefaultFilters(this.props.item.get('id'));
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.viewstate.get('currentCategory') !== nextProps.item.get('id') &&
      this.props.item.get('id') !== nextProps.item.get('id')
    ) {
      this.getPageData(nextProps.match.url, nextProps.item.get('id'));
      this.setDefaultFilters(nextProps.item.get('id'));
    }
  }

  getPageData(pageUrl, categoryId) {
    this.props.fetchCategoryMetaData({
      url: pageUrl
    });

    this.props.fetchProducts({
      id: categoryId,
      url: pageUrl
    });
  }

  setDefaultFilters(categoryId) {
    this.props.setViewstate('currentCategory', categoryId);
    this.props.setViewstate('sortAscending', false);
    this.props.setViewstate('sortBy', 'name');
    this.props.removeViewstate('filter');
    this.props.setViewstate('pagination', 0);
  }

  render() {
    const { currentCategory, categoryProducts, request, productsRequest } = this.props;
    const informationCard = currentCategory.getIn(['informationCards', 0]);

    if (request.get('statusCode') === 404) return <NotFoundPage />;
    if (request.get('status') === 'ERROR') return <ErrorPage />;

    return (
      <Page meta={currentCategory.get('metaData')} bgColor={color.lightGrey}>
        <Container>
          <Heading big center>
            {currentCategory.get('name')}
          </Heading>
          <Preamble>{currentCategory.get('description')}</Preamble>
        </Container>
        <ProductListWithFilters
          request={productsRequest}
          allProducts={categoryProducts}
          informationCard={informationCard}
        />
      </Page>
    );
  }
}

CategoryPage.defaultProps = {
  categoryProducts: Map(),
  viewstate: Map(),
  currentCategory: Map(),
  request: Map(),
  item: Map(),
  productsRequest: Map()
};

CategoryPage.propTypes = {
  match: PropTypes.object.isRequired,
  fetchProducts: PropTypes.func.isRequired,
  setViewstate: PropTypes.func.isRequired,
  removeViewstate: PropTypes.func.isRequired,
  viewstate: PropTypes.instanceOf(Map),
  categoryProducts: PropTypes.instanceOf(Map),
  currentCategory: PropTypes.instanceOf(Map),
  request: PropTypes.instanceOf(Map),
  item: PropTypes.instanceOf(Map),
  fetchCategoryMetaData: PropTypes.func.isRequired,
  productsRequest: PropTypes.instanceOf(Map)
};

export default connect(
  CategoryPage,
  { fetchProducts, fetchCategoryMetaData, setViewstate, removeViewstate },
  (store, props) => {
    const pathname = props.location.pathname.replace(/\/$/, '');

    const categoryProducts = props.item ? getProductsByKeys(store, ['categories'], props.item.get('id')) : Map();
    return {
      categoryProducts,
      viewstate: store.viewstate,
      currentCategory: store.categories.items.get(pathname),
      request: store.categories.request.get(pathname),
      productsRequest: store.products.request.get(pathname)
    };
  }
);



// WEBPACK FOOTER //
// ./src/pages/CategoryPage.js